export * from './apiAuth';
export * from './lti';
export * from './keycloak';
import { User } from '../users';

export interface MobileAuth {
  userID: number;
  appCode: string;
}

export enum ValidStatuses {
  invalidEmail = -1,
  neoid = 1,
  SSO = 2,
  evolveUser = 6,
}

export type ValidateEmail = {
  status: ValidStatuses;
  success: number;
  tempSent: boolean; // If a temporary password was sent.
  useAuthCode?: boolean; // If the app should use an auth code to login.
  passwordLoginRequired?: boolean; // If the web app should continue through password login.
  redirectURL?: string;
  school?: {
    schoolID: number;
    schoolName: string;
  };
  error?: string;
};

export type SessionData = {
  user?: User | null;
  csrfToken?: string;
  sessionID?: string;
};
